import { render, staticRenderFns } from "./InternalFormSubmitted.vue?vue&type=template&id=49a20797"
import script from "./InternalFormSubmitted.vue?vue&type=script&lang=js"
export * from "./InternalFormSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports